<template>
  <div>
    <PersonalAreaNavBar
      :title="$t('mainMenu.contactName')"
      backurl="personal-area-mainmenu"
    />
    <PersonalAreaNoInternet />
    <div class="pam-content lang-dir">
      <div
        style="padding: 0px 15px"
        :style="{ 'padding-top': $store.state.hasInternet ? '15px' : '0px' }"
      >
        <PersonalAreaSendRequest v-if="$store.state.hasInternet" />
        <PersonalAreaMenuLineTitle :msg="$t('personalArea.contactUs')" />
        <PersonalAreaItemInfo
          :rtitle="$t('personalArea.tel')"
          icon="tel"
          icon_height="16"
          icon_width="16"
          >02-5866078</PersonalAreaItemInfo
        >
        <PersonalAreaItemInfo
          :rtitle="$t('contactUs.compantWhatsApp')"
          icon="pa-whatsapp"
          icon_height="16"
          icon_width="16"
          >02-5712713</PersonalAreaItemInfo
        >
        <PersonalAreaItemInfo
          :rtitle="$t('login.email')"
          icon="pa-mail"
          icon_height="16"
          icon_width="16"
          >otzar@otzar.biz</PersonalAreaItemInfo
        >
        <PersonalAreaItemInfo
          :rtitle="$t('general.fax')"
          icon="pa-fax"
          icon_height="16"
          icon_width="16"
          >02-5712713</PersonalAreaItemInfo
        >
        <PersonalAreaItemInfo
          :rtitle="$t('login.address')"
          icon="pa-address"
          icon_height="16"
          icon_width="16"
          :icontop="true"
        >
          <div style="line-height: 20px">
            {{ $t("contactUs.companyAddress") }}<br />
            {{ $t("contactUs.companyPO") }}<br />
            <!-- מיקוד ת.ד. 23609<br /> -->
            {{ $t("contactUs.companyLocation") }}
            {{ $t("contactUs.companyCountry") }}
          </div>
        </PersonalAreaItemInfo>
        <PersonalAreaItemInfo
          :rtitle="$t('personalArea.publicTrasport')"
          icon="pa-bus"
          icon_height="16"
          icon_width="16"
          :icontop="true"
        >
          <div style="line-height: 20px">
            {{ $t("personalArea.localBusLines") }}<br />
            <b>36, 67, 64, 72, 71, 506, 40, 54</b>
          </div>
        </PersonalAreaItemInfo>
        <PersonalAreaItemInfo
          :rtitle="$t('personalArea.openhours')"
          icon="pa-clock"
          icon_height="16"
          icon_width="16"
          :icontop="true"
        >
          <div style="line-height: 20px">
            {{ $t("personalArea.opendays") }}<br />
            8:30 - 16:00
          </div>
        </PersonalAreaItemInfo>
      </div>
    </div>
  </div>
</template>

<script>
import PersonalAreaNavBar from "./PersonalAreaNavBar.vue";
import PersonalAreaNoInternet from "./PersonalAreaNoInternet.vue";
import PersonalAreaMenuLineTitle from "./PersonalAreaMenuLineTitle.vue";
import PersonalAreaItemInfo from "./PersonalAreaItemInfo.vue";
import PersonalAreaSendRequest from "./PersonalAreaSendRequest.vue";
export default {
  components: {
    PersonalAreaNavBar,
    PersonalAreaNoInternet,
    PersonalAreaMenuLineTitle,
    PersonalAreaItemInfo,
    PersonalAreaSendRequest,
  },
};
</script>

<style lang="scss" scoped>
.pam-content {
  // padding-top: 15px;
}
.spacer {
  padding: 15px;
}
</style>
